import { call, put, takeLatest, select } from 'redux-saga/effects'
import { defineTypes } from '../../helpers'
import { reduxFetch } from '../../http/reduxFetch'
import UsersEndpoint from '../../persistence/UserEndpoint'
import SessionEndpoint from '../../persistence/SessionEndpoint'
import { sessionSaga, actions as sessionActions } from '../session'
import { selectors as sessionSelectors } from '../session'
import { push } from 'react-router-redux'

const user_types = { ...defineTypes('USERS') }
const sessionTypes = { ...defineTypes('SESSION/POST') }

export const initialState = {
  started: false,
  loading: false,
  loaded: false,
  link_checked: false,
  checking_link: false,
  errors: {}
}

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case user_types.REQUEST:
      return { ...state, started: true, loading: true }
    case user_types.FAILURE:
      return { ...state, loading: false, errors: action.error }
    case user_types.SUCCESS:
      return { ...state, loading: false, loaded: true, link_checked: action.link_checked || false, link_valid: action.link_valid || false }
    case 'CHECK_INVITE_LINK':
      return { ...state, link_checked: false, loading: true, loaded: false, link_id: action.link_id }
    default:
      return state
  }
}

export const actions = {
  submitUserForm () {
    return { type: 'SUBMIT_USER_FORM' }
  },
  checkInviteLink (link_id) {
    return { type: 'CHECK_INVITE_LINK', link_id: link_id, checking_link: true }
  }
}

export const selectors = {
  new_user_form: (store) => {
    return store.form.new_user
  },
  errors: (store) => {
    return store
      && store.new_user
      && store.new_user.errors
  },
  link_id: ({ new_user }) => {
    return new_user
    && new_user.link_id
  },
  link_valid: ({ new_user }) => {
    return new_user
    && new_user.link_valid
  },
  checking_link: ({ new_user }) => {
    return new_user
    && new_user.checking_link
  }
}

export function * SignUpSaga (action) {
  try {
    let sign_up_form = {}
    const form = yield select(selectors.new_user_form)
    sign_up_form['user'] = form['values']
    let email = form['values'] && form['values']['email']
    let password = form['values'] && form['values']['password']
    let link_id = yield select(selectors.link_id)

    sign_up_form['user']['link_id'] = link_id
    sign_up_form['user']['first_name'] = form['values']['firstName']
    sign_up_form['user']['last_name'] = form['values']['lastName']

    const response = yield call(reduxFetch, UsersEndpoint.new(sign_up_form))
    const login_response = yield call(sessionSaga, { email: email, password: password })

    if (response['data']) {
      let location = link_id
        ? {
            pathname: '/reservations'
          }
        : {
            pathname: '/account_information',
            state: {
              userId: response['data'] && response['data']['id']
            }
          }
      yield put(push(location))
      yield put({ type: user_types.SUCCESS })
    } else {
      yield put({ type: user_types.FAILURE, error: response['errors'] })
    }
  } catch (error) {
    yield put({ type: user_types.FAILURE, error })
  }
}

export function * checkInviteLink () {
  try {
    const link_id = yield select(selectors.link_id)
    const response = yield call(reduxFetch, UsersEndpoint.check(link_id))
    if (response['data']) {
      yield put({ type: user_types.SUCCESS, checking_link: false, link_valid: true })
    } else {
      yield put({ type: user_types.FAILURE, checking_link: false, link_valid: false, error: response['errors'] })
    }
  } catch (error) {
    yield put({ type: user_types.FAILURE, checking_link: false, link_valid: false, error })
  }
}

export function * rootSaga () {
  yield takeLatest('SUBMIT_USER_FORM', SignUpSaga)
  yield takeLatest('CHECK_INVITE_LINK', checkInviteLink)
}



// WEBPACK FOOTER //
// ./src/sagas/sign_up/new.js